// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: #f7f7f7;
}

.subscription-card {
  max-width: 600px;
  width: 100%;
}

.subscription-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1rem;
}

.subscription-content h2 {
  margin: 1.5rem 0 1rem;
  color: #333;
}

.subscription-message {
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  padding: 1rem;
  margin: 1rem 0;
  width: 100%;
  text-align: left;
}

.subscription-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  width: 100%;
  max-width: 300px;
}

.patreon-link {
  text-decoration: none;
  width: 100%;
}

@media (max-width: 600px) {
  .subscription-page {
    padding: 1rem;
  }
  
  .subscription-card {
    box-shadow: none;
    border: none;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/pages/Subscription/SubscriptionRequired.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":[".subscription-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 2rem;\n  background-color: #f7f7f7;\n}\n\n.subscription-card {\n  max-width: 600px;\n  width: 100%;\n}\n\n.subscription-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 1rem;\n}\n\n.subscription-content h2 {\n  margin: 1.5rem 0 1rem;\n  color: #333;\n}\n\n.subscription-message {\n  background-color: #fffbe6;\n  border: 1px solid #ffe58f;\n  border-radius: 4px;\n  padding: 1rem;\n  margin: 1rem 0;\n  width: 100%;\n  text-align: left;\n}\n\n.subscription-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 2rem;\n  width: 100%;\n  max-width: 300px;\n}\n\n.patreon-link {\n  text-decoration: none;\n  width: 100%;\n}\n\n@media (max-width: 600px) {\n  .subscription-page {\n    padding: 1rem;\n  }\n  \n  .subscription-card {\n    box-shadow: none;\n    border: none;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
